<div class="mt-2">
  <div class="externe-daten">
    @if (entry) {
      <cap-content-header>
        <cap-title> {{ "titel.zentralePerson" | translate }} {{ entry.bezeichnung }}</cap-title>
      </cap-content-header>
    }
    @if (entry) {
      <div class="row mt-2">
        <div class="col-md-6 col-sm-12">
          @if (hasAuskunftsperre()) {
            <div>
              <span
                [ngbTooltip]="'stammperson-auskunftsperre-mitBerechtigung' | translate"
                [placement]="'bottom'"
                class="ms-1 fas fa-exclamation-triangle text-warning"></span>
            </div>
          }
          <cap-kopfdatenelement label="Name/Bezeichnung1">
            {{ entry.name }}
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="Vorname/Bezeichnung2">
            {{ entry.vorname }}
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="AHVNummer">
            @if (entry?.mAhvNummer.access !== AccessEnum.NONE) {
              <span>
                {{ entry.ahvNummer | formatAhv }}
              </span>
            } @else {
              <ng-container>
                {{ "gemaessZPV" | translate }}
              </ng-container>
            }
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="AHVVersichertennummer">
            @if (entry?.mAhvNummer13.access !== AccessEnum.NONE) {
              <span>
                {{ entry.ahvNummer13 | formatAhv }}
              </span>
            } @else {
              <ng-container>
                {{ "gemaessZPV" | translate }}
              </ng-container>
            }
          </cap-kopfdatenelement>
        </div>
        <div class="col-md-6 col-sm-12">
          <cap-kopfdatenelement label="Anrede">
            {{ entry.anrede?.text | translateName }}
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="TodesdatumLiquidationsdatuminaktivSeit">
            @if (entry?.mTodesdatum.access !== AccessEnum.NONE) {
              <span>
                {{ entry.todesdatum | datum }}
              </span>
            } @else {
              <ng-container>
                {{ "gemaessZPV" | translate }}
              </ng-container>
            }
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="GeburtsdatumGruendungsdatumaktivVon">
            @if (entry?.mGeburtsdatum.access !== AccessEnum.NONE) {
              <span>
                {{ entry.geburtsdatum | datum }}
              </span>
            } @else {
              <ng-container>
                {{ "gemaessZPV" | translate }}
              </ng-container>
            }
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="ZPVNummer">
            {{ entry.fremdId }}
          </cap-kopfdatenelement>
          <cap-kopfdatenelement label="UID">
            {{ entry.unternehmensId }}
          </cap-kopfdatenelement>
        </div>
      </div>
    }
    @if (entry) {
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <cap-kopfdatenelement [labelClass]="'col-md-2'" label="Adresse">
            @if (entry.adressen[0]) {
              <cap-kompakt-personenadresse [entry]="entry" [item]="entry.adressen[0]"></cap-kompakt-personenadresse>
            }
          </cap-kopfdatenelement>
        </div>
      </div>
    }
  </div>

  @if (entry) {
    <div class="row mt-2">
      <div class="col-md-6 col-sm-12">
        @if (stammPersonMaster) {
          <cap-kopfdatenelement label="StammpersonImGrundbuch">
            <cap-link
              [params]="[stammPersonMaster.masterId.id, stammPersonMaster.version.id.id]"
              [target]="navTargets.NAV_PERSON_STAMM"
              [tooltipParams]="stammPersonMaster | tooltipPersonstammPipe">
              <cap-kompakt-stammperson
                [auskunftsperre]="stammPersonMaster.auskunftsperre"
                [item]="stammPersonMaster.version"></cap-kompakt-stammperson>
            </cap-link>
          </cap-kopfdatenelement>
        }
      </div>
    </div>
  }

  <cap-rubrik [id]="'eintragungenImGrundbuch'" [isClosable]="true" [isOpen]="true">
    <ng-container title>
      <h3 class="mb-0">{{ "eigentumImGrundbuch" | translate }}</h3>
    </ng-container>
    @if (stammPersonLoaded) {
      <cap-personstamm-eigentum [mitHist]="false" [personStammMasterId]="stammPersonMaster?.masterId"></cap-personstamm-eigentum>
    }
  </cap-rubrik>

  <cap-rubrik [id]="'eintragungenImGrundbuch'" [isClosable]="true" [isOpen]="true">
    <ng-container title>
      <h3 class="mb-0">{{ "uebrigeBerechtigungenImGrundbuch" | translate }}</h3>
    </ng-container>
    @if (stammPersonLoaded) {
      <cap-personstamm-uebrige-berechtigungen [mitHist]="false" [personStammMasterId]="stammPersonMaster?.masterId">
      </cap-personstamm-uebrige-berechtigungen>
    }
  </cap-rubrik>

  <cap-rubrik [id]="'eintragungenImGrundbuch'" [isClosable]="true" [isOpen]="true">
    <ng-container title>
      <h3 class="mb-0">{{ "eintragungAmtlicheBewertung" | translate }}</h3>
    </ng-container>
    @if (entry) {
      <cap-neskoab-grundstuecke-zpvpersonen [zpvNummer]="entry.fremdId"></cap-neskoab-grundstuecke-zpvpersonen>
    }
  </cap-rubrik>
</div>
